{
  "2024-25": {
    "year": "2024-2025",
    "firstDayTeachers": "2024-08-12",
    "firstDay": "2024-08-14",
    "lastDay": "2025-06-05",
    "exams": {
      "s1": {
        "start": "2024-12-18",
        "end": "2024-12-20"
      },
      "s2": {
        "start": "2025-06-02",
        "end": "2025-06-04"
      }
    },
    "apExams": {
      "start": "2025-05-05",
      "end": "2025-05-16"
    },
    "holidays": [
      "2024-09-02",
      "2024-10-07",
      "2024-10-14",
      "2024-11-01",
      "2024-11-11",
      "2024-11-25",
      "2024-11-26",
      "2024-11-27",
      "2024-11-28",
      "2024-11-29",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-20",
      "2025-01-27",
      "2025-02-14",
      "2025-02-17",
      "2025-03-14",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-05-16",
      "2025-05-26"
    ],
    "breakNames": {
      "2024-11-23": "Thanksgiving break",
      "2024-12-21": "Winter break",
      "2025-02-14": "Presidents’ Day Weekend",
      "2025-03-29": "Spring break"
    }
  },
  "2023-24": {
    "year": "2023-2024",
    "firstDay": "2023-08-16",
    "lastDay": "2024-06-04",
    "exams": {
      "s1": {
        "start": "2023-12-20",
        "end": "2023-12-22"
      },
      "s2": {
        "start": "2024-05-29",
        "end": "2024-05-31"
      }
    },
    "apExams": {
      "start": "2024-05-06",
      "end": "2024-05-17"
    },
    "holidays": [
      "2023-09-04",
      "2023-10-09",
      "2023-10-27",
      "2023-11-10",
      "2023-11-20",
      "2023-11-21",
      "2023-11-22",
      "2023-11-23",
      "2023-11-24",
      "2023-12-25",
      "2023-12-26",
      "2023-12-27",
      "2023-12-28",
      "2023-12-29",
      "2024-01-01",
      "2024-01-02",
      "2024-01-03",
      "2024-01-04",
      "2024-01-05",
      "2024-01-15",
      "2024-01-29",
      "2024-02-16",
      "2024-02-19",
      "2024-04-01",
      "2024-04-02",
      "2024-04-03",
      "2024-04-04",
      "2024-04-05",
      "2024-05-17",
      "2024-05-27"
    ],
    "breakNames": {
      "2023-11-18": "Thanksgiving break",
      "2023-12-23": "Winter break",
      "2024-02-16": "Presidents’ Day Weekend",
      "2024-03-30": "Spring break"
    }
  },
  "2022-23": {
    "year": "2022-2023",
    "firstDay": "2022-08-15",
    "lastDay": "2023-06-02",
    "exams": {
      "s1": {
        "start": "2022-12-14",
        "end": "2022-12-16"
      },
      "s2": {
        "start": "2023-05-30",
        "end": "2023-06-01"
      }
    },
    "apExams": {
      "start": "2023-05-01",
      "end": "2023-05-12"
    },
    "holidays": [
      "2022-09-05",
      "2022-10-10",
      "2022-10-28",
      "2022-11-11",
      "2022-11-21",
      "2022-11-22",
      "2022-11-23",
      "2022-11-24",
      "2022-11-25",
      "2022-12-19",
      "2022-12-20",
      "2022-12-21",
      "2022-12-22",
      "2022-12-23",
      "2022-12-26",
      "2022-12-27",
      "2022-12-28",
      "2022-12-29",
      "2022-12-30",
      "2023-01-02",
      "2023-01-16",
      "2023-02-17",
      "2023-02-20",
      "2023-04-03",
      "2023-04-04",
      "2023-04-05",
      "2023-04-06",
      "2023-04-07",
      "2023-05-15",
      "2023-05-29"
    ],
    "breakNames": {
      "2022-11-19": "Thanksgiving break",
      "2022-12-17": "Winter break",
      "2023-02-17": "Presidents’ Day Weekend",
      "2023-04-01": "Spring break"
    }
  }
}
